var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "cruise-info__dates" }, [
    _c("div", { staticClass: "cruise-info__start" }, [
      _c("div", { staticClass: "dd" }, [
        _vm._v(_vm._s(_setup.props.dates.dateStartOb.format(_setup.FORMAT1))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tt" }, [
        _vm._v(_vm._s(_setup.props.dates.dateStartOb.format(_setup.FORMAT2))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cruise-info__duration" }, [
      _c("span", [_vm._v(_vm._s(_setup.numWord(_setup.props.dates.days)))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cruise-info__end" }, [
      _c("div", { staticClass: "dd" }, [
        _vm._v(_vm._s(_setup.props.dates.dateEndOb.format(_setup.FORMAT1))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tt" }, [
        _vm._v(_vm._s(_setup.props.dates.dateEndOb.format(_setup.FORMAT2))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }